module.exports = __webpack_public_path__ + "media/images/about-film-b6ec9f396b5ee8522ef32a9158fd349a.png";